import {clone} from "@/util/utils.js"

export default clone({
    empresaId: 1,
    tipoBeneficiario: 2,
    cpfTitular: 3,
    parentesco: 4,
    cpf: 5,
    nome: 6,
    dataNascimento: 7,
    genero: 8,
    estadoCivil: 9,
    localTrabalho: 10,
    unidade: 11,
    cnpjFaturamento: 12,
    dataAdmissao: 13,
    endereco: 14,
    bairro: 15,
    cep: 16,
    estado: 17,
    cidade: 18,
    telefoneResidencial: 19,
    telefoneComercial: 20,
    telefoneCelular: 21,
    email1: 22,
    email2: 23,
   // matricula: 24,
    ghe: 24,
    setor: 25,
    funcao: 26
})